// hooks/useRetryCountdown.js
import { useState, useEffect, useCallback } from 'react';

/**
 * Hook personnalisé pour gérer un countdown sur les boutons retry
 * @param {number} initialDelay - Délai initial en secondes (défaut: 3)
 * @returns {Object} - { countdown, isCountingDown, startCountdown, getButtonText, isDisabled }
 */
export const useRetryCountdown = (initialDelay = 3) => {
  const [countdown, setCountdown] = useState(0);
  const [isCountingDown, setIsCountingDown] = useState(false);

  // Démarrer le countdown
  const startCountdown = useCallback(() => {
    setCountdown(initialDelay);
    setIsCountingDown(true);
  }, [initialDelay]);

  // Reset le countdown
  const resetCountdown = useCallback(() => {
    setCountdown(0);
    setIsCountingDown(false);
  }, []);

  // Effet pour gérer le countdown
  useEffect(() => {
    let interval;
    
    if (isCountingDown && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            setIsCountingDown(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isCountingDown, countdown]);

  // Texte du bouton
  const getButtonText = useCallback(() => {
    if (isCountingDown && countdown > 0) {
      return `Retry (${countdown})`;
    }
    return 'Retry';
  }, [isCountingDown, countdown]);

  return {
    countdown,
    isCountingDown,
    startCountdown,
    resetCountdown,
    getButtonText,
    isDisabled: isCountingDown && countdown > 0
  };
};